import React, { useEffect, useState} from 'react';
import { useAuth } from '../utils/AuthContext';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { getCredit, getAcc, regAcc, reqWthd } from '../api/credit';
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import ProfileLoading from '../components/ProfileLoading';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/Dashboard.css"


const AccountProfile = () => {
  const [loading, setLoading] = useState(true);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const { type } = useParams();
  const { user, logout } = useAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const [consoleError, setConsoleError] = useState("");
  const [infoCredit, setCredit] = useState();
  const [infoAcc, setAcc] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [selectedAcc, setSelectedAcc] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(4682); 
  const [formData, setFormData] = useState({
    holders_fn: "",
    holders_ln: "",
    iban: "",
    expiry_m: "",
    expiry_y: "",
    card_no: "",
    provider_name:"",
  });

  const [formDataWth, setFormDataWth] = useState({
    regaccount: "",
    amount_wtdr_IRT: "",
  });

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location]);


  useEffect(() => {
    const tabFromUrl = searchParams.get("type");
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  
  useEffect(() => {
    fetch("/data/Institutes.json")
      .then((res) => res.json())
      .then((data) => setBanks(data.Institudes["banks"]))
      .catch((err) => setConsoleError("Error loading content:", err));
  },[]);
  
  useEffect(() => {
    if (!user) return;  
    setLoading(true); 
    getCredit(user)
      .then(res => {
        setCredit(res.data[-0]);  
      })
      .catch(err => {
        setCredit(null);  
      })
      .finally(() => {
        setLoading(false); 
      });
  }, [user]); 

  useEffect(() => {
    if (!user) return;  
    getAcc(user)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setAcc(res.data);
        } else if (res.data.results) {
          setAcc(res.data.results);
        }
      })
      .catch(err => {
        setAcc(null);  
      })
      .finally(() => {
        setLoading(false); 
      });
  }, [user]); 


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeWth = (e) => {
    const { name, value } = e.target;
    setFormDataWth((prev) => ({ ...prev, [name]: value }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setSelectedBank(e.target.value);
  };
  
  const handleAccSelect = (e) => {
    const { name, value } = e.target;
    setFormDataWth((prev) => ({ ...prev, [name]: value }));
    setSelectedAcc(e.target.value);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.entries(formData).forEach(([key, val]) => data.append(key, val));
  
    try {
      await regAcc(data);
      setFormData({
        holders_fn: "",
        holders_ln: "",
        iban: "",
        expiry_m: "",
        expiry_y: "",
        card_no: "",
        provider_name:"",
      });

      setError("");
      alert(setlang==="en"?"Account registered successfully.":"حساب کاربریت با موفقیت ثبت شد، حالا میتونی وارد پروفایل شخصیت بشی");
      window.location.reload()
    } catch (err) {
      setError(err.message || "Failed to register account");
    }
  };

  const handleSubmitWth = async (e) => {
    e.preventDefault();
  
    const dataWth = new FormData();
    Object.entries(formDataWth).forEach(([key, val]) => dataWth.append(key, val));
  
    try {
      await reqWthd(dataWth);
      setFormDataWth({
        regaccount: "",
        amount_wtdr_IRT: "",
      });
      
      setError("");
      alert(setlang==="en"?"Request sent successfully.":"درخواست با موفقیت دریافت شد");

    } catch (err) {
      setError(err.message || "Failed to send request");
    }
  };

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  if (loading) return <Loading />;

  if (!user) {
    return (
      <>
        <div className="dashboard">
          <NavbarLog />
          <Sidebar />
          {setlang === "en" ? 
          <div className="messaging-page">
            You must be logged in to view your profile<Link to={`/${lang}/login`}>login here</Link>!
          </div>
          :
          <div className="messaging-page">
          ! برای نمایش پروفایل لطفا <Link to={`/${lang}/login`}>از اینجا وارد شو</Link>!
          </div>
          }
          <Footer />
        </div>
      </>
    );
  }

  if (!loading)
  return (
    <>
      <NavbarLog />
      <Sidebar />
      <div className={setlang==="en"?"dashboard-en":"dashboard-fa"}>
        <div className="main-content">
          {user.error ? (
            <div className="error-message">
              <p>{user.error}</p>
            </div>
          ) : (
            <>
              {/* Welcome Section with Profile Picture */}
              {setlang === "en" ? 
              <div className="welcome-bar">
                <div className="welcome-text">
                  <h3>Welcome, {user.first_name}!</h3>
                  <p className="text-block">Email: {user.email}</p>
                  <p className="text-block">
                    <small>Joined: {toPersiDigits(dayjs.utc(user.date_joined).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</small> 
                  </p>
                </div>
                {user.profile_picture && (
                  <div className="welcome-picture">
                    <img src={user.profile_picture_url} alt="Profile" />
                  </div>
                )}
              </div>
              :
              <div className="welcome-bar">
                {user.profile_picture && (
                  <div className="welcome-picture">
                    <img src={user.profile_picture_url} alt="Profile" />
                  </div>
                )}
                <div className="welcome-text">
                  <h3>{user.first_name}, خوش آمدید</h3>
                  <p className="text-block">{user.email} :ایمیل</p>
                  <p className="text-block">
                    <small>تاریخ عضویت: {dayjs.utc(user.date_joined).calendar("jalali").locale("fa").format("YYYY/MM/DD")} </small>
                  </p>
                </div>
              </div>
              }
  
              {/* Personal Information */}
              {infoCredit && (
                <>
                {setlang === "en" ?
                  <div className="info-section">
                    <h2>Account Balance</h2>
                    <div className="info-grid">
                      <p><strong>Available Balance:</strong>{" IRT " + new Number(infoCredit.amount_available_IRT).toLocaleString() || "0 IRT"}</p>
                      <p><strong>Reserved Bids:</strong>{" IRT " + new Number(infoCredit.amount_reserved_IRT).toLocaleString()|| "0 IRT"}</p>
                      <p><strong>Orders:</strong>{" IRT " + new Number(infoCredit.amount_blocked_IRT).toLocaleString() ||  "0 IRT"}</p>
                      <p><strong>Last Transaction</strong>{dayjs.utc(infoCredit.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm") ||  "No Transaction yet!"}</p>
                    </div>
                  </div> :
                  <div className="info-section">
                    <h2>کیف پول</h2>
                    <div className="info-grid">
                      <p>{" تومان " + toPersiDigits(new Number(infoCredit.amount_reserved_IRT).toLocaleString()) || "0 تومان"}<strong> :موجودی رزرو</strong></p>
                      <p>{" تومان " + toPersiDigits(new Number(infoCredit.amount_available_IRT).toLocaleString()) || "0 تومان"}<strong> :موجودی باز</strong></p>
                      <p>{" تومان " + toPersiDigits(new Number(infoCredit.amount_blocked_IRT).toLocaleString()) ||  "0 تومان"}<strong> :خرید</strong></p>
                      <p>{toPersiDigits(dayjs.utc(infoCredit.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")) ||  "No Transaction yet!"}<strong> :آخرین تراکنش</strong></p>
                    </div>
                  </div>
                }

                  {/*
                <div >
                  <div className="payment-tabs-container">
                    <button className={activeTab === 4682 ? "active" : ""} onClick={() => setActiveTab(4682)} >{setlang === "en" ? "Deposit" : "واریز" }</button>
                    <button className={activeTab === 2246 ? "active" : ""} onClick={() => setActiveTab(2246)} >{setlang === "en" ? "Withdraw" : "برداشت" }</button>
                  </div>
                  {infoAcc.length > 0 ? (
                    activeTab === 4682 ? (
                      <div className='info-bk'>
                        <p><strong>Bank:</strong> Bank of Iran</p>
                        <p><strong>Account Name:</strong> MyWebsite</p>
                        <p><strong>IBAN:</strong> IR12 3456 7891 0111 2131 4151 06</p>
                        <p><strong>Card:</strong> 1234 5678 1234 5678</p>
                      </div>
                    ):(
                      <form onSubmit={handleSubmitWth} className="AccountForm-container">
                        <div className="grid-item">
                          <div className='grid-comp-w'>
                            <select name="regaccount" value={formDataWth.regaccount} onChange={handleAccSelect} className="narrow-select" placeholder="Name of the Bank" >
                              <option value="">-- Select Your Account --</option>
                              {Object.values(infoAcc).map((acc, idx) => ( 
                                <option key={idx} value={acc.id}>
                                  {acc.provider_name} - {acc.holders_fn} {acc.holders_ln} - {acc.iban_pref} {acc.iban}
                                </option>
                              ))}
                            </select>
                            Amount to Withdraw: IRT
                            <input name="amount_wtdr_IRT" value={formDataWth.amount_wtdr_IRT} onChange={handleChangeWth} className='input-medium' placeholder="Minimum withdraw amount 10,000 IRT" required />
                            <button name="amount_wtdr_IRT" value={infoCredit.amount_available_IRT} onClick={handleChangeWth} className='textselect-bt'>Withdraw all credit IRT {new Number(infoCredit.amount_available_IRT).toLocaleString()}</button>
                          </div>
                          <div className="form-button-container">
                            <button type="submit">Withdraw</button>
                          </div>
                        </div>
                      </form>
                    )
                  ):(
                    <>
                      <form onSubmit={handleSubmit} className="AccountForm-container">
                        <div className="grid-item">
                          <p><strong>Please register your bank account</strong></p>
                          <p><strong> </strong></p>
                          <div className='grid-comp'>
                            <input name="holders_fn" value={formData.holders_fn} onChange={handleChange} placeholder="First Name" className='input-medium' required/>
                            <input name="holders_ln" value={formData.holders_ln} onChange={handleChange} placeholder="Last Name" className='input-medium' required/>
                          </div>
                          <div className='grid-comp'>
                            <select name="provider_name" value={formData.provider_name} onChange={handleBankChange} className="narrow-select" placeholder="Name of the Bank" >
                                <option value="">-- Select Bank --</option>
                                  {banks.map((bank, idx) => ( <option key={idx} value={bank}> {bank} </option>))}
                              </select>
                          </div>
                          <div className='grid-comp'>
                            IR <input name="iban" maxLength={28} value={formData.iban} onChange={handleChange} placeholder="IBAN" className='input-large' required/>
                          </div>
                          <div className='grid-comp'> Card No. 
                            <input name="card_no" maxLength={16} value={formData.card_no} onChange={handleChange} className='input-medium'/>
                          </div>  
                          <div className="grid-comp"> Card Expiry: 
                            <input name="expiry_m"  maxLength={2} value={formData.expiry_m} onChange={handleChange} placeholder="Month" className='input-card' required/>
                            <input name="expiry_y" maxLength={2} value={formData.expiry_y} onChange={handleChange} placeholder="Year" className='input-card' required/>
                          </div>
                        </div>
                        <div className="form-button-container">
                          <button type="button">Cancel</button>
                          <button type="submit">Register Account</button>
                        </div>
                      </form>
                    </>
                  )}
                </div>
                  */}
              </>
              )}
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AccountProfile;